{
  "close": "Κλείσιμο"
}
